export default "__VITE_ASSET__BnbqsVEp__"